import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "418",
  "slug": "spot-bangladesh-from-satellite-imagery",
  "title": "How to Recognise Bangladesh in Satellite Images",
  "excerpt": "The lower Ganges–Brahmaputra–Meghna system is a useful starting point.",
  "date": "2026-06-12",
  "category": "Geography",
  "image": "/blog-images/bangladesh.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "The lower Ganges–Brahmaputra–Meghna system is a useful starting point. Broad channels, sandbars, cultivated floodplains, and the tidal creeks of the Sundarbans occupy much of the regional view. Channel widths and exposed bars change with river flow, so images from different seasons may look quite different."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Follow a major channel toward the Bay of Bengal. Separate the branching coastal channels from the wider inland river network. The Sundarbans extends into India, and much of the plain continues across the border; a green delta landscape alone cannot place you on the Bangladeshi side. The hills in the southeast provide a contrasting feature, but hill country also occurs elsewhere in the surrounding region."
    }
  ],
  "imageAlt": "Bangladesh regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
